import { render, staticRenderFns } from "./Anwesenheitsliste.vue?vue&type=template&id=2d3b8b8d&"
import script from "./Anwesenheitsliste.vue?vue&type=script&lang=js&"
export * from "./Anwesenheitsliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports